
      const   userinformation = JSON.parse(localStorage.getItem("user"))
              
      export default userinformation